import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SaldoPermissionConstants} from '../../../app.constants';
import {TableColumn} from '../../../modules/common/models/table.column.model';
import {SourceClassifierTree} from '../../../models/source-classifier-tree';
import {SourceClassifierService} from '../../../services/source-classifier.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {UserInfoService} from '../../../services/userinfo.service';
import {ArrayUtils} from '../../../utils/ArrayUtils';
import {DownloadSetup} from '../../../utils/DownloadSetup';
import {MediaTypeConstant} from '../../../models/media-type-constant';

@Component({
  selector: 'saldo-source-view',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './source.component.html',
  styleUrls: ['./source.component.scss']
})
export class SourceComponent implements OnInit {
  isAdministrator = false;

  list: SourceClassifierTree[];
  columns: TableColumn[];
  loaded = false;
  dwnLoaded = true;


  constructor(private router: Router,
              private route: ActivatedRoute,
              private sourceClassifierService: SourceClassifierService,
              private userInfoService: UserInfoService,
              private toastr: ToastrService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    const userInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    if (userInfo) {
      this.isAdministrator = this.userInfoService.hasRoleWithUserInfo(SaldoPermissionConstants.ADMINISTRATOR, userInfo);
    }
    this.columns = this.getColumns();
    this.refreshTable();
  }

  goToEditPage(id) {
    this.router.navigate(['muuda/' + id], {queryParams: {id}, relativeTo: this.route});
  }

  goToNewAccountClassifier(code) {
    if (code) {
      this.router.navigate(['uus'], {queryParams: {code}, relativeTo: this.route});
    } else {
      this.router.navigate(['uus'], {relativeTo: this.route});
    }
  }

  deleteItem(id) {
    this.sourceClassifierService.removeSourceClassifier(id).subscribe(() => {
      ArrayUtils.removeRow(this.list, id);
      this.toastr.success('Allikas eemaldatud.', 'Teade', {
        positionClass: 'toast-top-right', closeButton: true, tapToDismiss: false
      });
    }, error => {
      this.toastr.error(this.translate.instant(error), 'Teade', {
        positionClass: 'toast-top-right', closeButton: true, tapToDismiss: false
      });
    });
  }

  refreshTable() {
    this.sourceClassifierService.getSourceClassifiers().subscribe(res => {
      this.list = res.child;
      this.loaded = true;
    });
  }

  getColumns(): TableColumn[] {
    return [
      {
        name: 'title',
        label: 'Nimetus',
      },
      {
        name: 'code',
        label: 'Kood'
      },
      {
        name: 'validTo',
        label: 'Kehtiv kuni',
      }];
  }

  saveAsExcel() {
    this.dwnLoaded = false;
    this.sourceClassifierService.downloadExcel().subscribe(response => {
      DownloadSetup.setupDownloadProperties(MediaTypeConstant.EXCEL, response, 'Allikad.xls');
      this.dwnLoaded = true;
    }, () => {
      this.dwnLoaded = true;
    });
  }

  saveAsXml() {
    this.dwnLoaded = false;
    this.sourceClassifierService.downloadXml().subscribe(response => {
      DownloadSetup.setupDownloadProperties(MediaTypeConstant.XML, response, 'Allikad.xml');
      this.dwnLoaded = true;
    }, () => {
      this.dwnLoaded = true;
    });
  }

  hasAdministratorRole() {
    return this.isAdministrator;
  }
}
